"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWaitFor = void 0;
var react_1 = require("react");
/**
 * Fires the given `fn` a single time once all the given preconditions are `true`.
 *
 * @example
 * ```tsx
 * const Page = () => {
 *  const dataset1Loaded = useState(false);
 *  const dataset2Loaded = useState(false);
 *
 *  // load the data ...
 *
 *  // Trigger the print dialog once the component is ready
 *  useWaitFor(() => window.print(), dataset1Loaded, dataset2Loaded);
 *
 *  return dataset1Loaded && dataset2Loaded ? <Content /> : <Loader />;
 * }
 *
 * @category Hook
 * ```
 */
function useWaitFor(fn) {
    var preconditions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        preconditions[_i - 1] = arguments[_i];
    }
    var _a = __read((0, react_1.useState)(false), 2), done = _a[0], setDone = _a[1];
    (0, react_1.useEffect)(function () {
        if (done)
            return;
        if (preconditions.some(function (v) { return !v; }))
            return;
        fn();
        setDone(true);
    }, preconditions);
}
exports.useWaitFor = useWaitFor;
